export class ServerConstants {

  //Command Names

  public static CREATE_TLD_COMMAND = 'CreateTopLevelDomainCommand';

  public static UPDATE_TLD_COMMAND = 'UpdateTopLevelDomainCommand';

  public static UPDATE_CHANGE_REQUEST_COMMAND = 'UpdateChangeRequestCommand';

  public static DIRECT_EDIT_TLD_COMMAND = 'DirectUpdateTopLevelDomainCommand';

  public static TRANSFER_TLD_COMMAND = 'TransferTopLevelDomainCommand';

  public static PERFORM_WORKFLOW_ACTION_COMMAND = 'PerformWorkflowActionCommand';

  public static WITHDRAW_CHANGE_REQUEST_COMMAND = 'WithdrawChangeRequestCommand';

  public static TECH_CHECK_RETEST_COMMAND = 'TechCheckRetestCommand';

  public static APPROVE_CHANGE_REQUEST_COMMAND = 'ApproveChangeRequestCommand';

  public static REJECT_CHANGE_REQUEST_COMMAND = 'RejectChangeRequestCommand';

  public static ASSIGN_CHANGE_REQUEST_COMMAND = 'AssignChangeRequestCommand';

  public static UPDATE_CHANGE_REQUEST_ATTRIBUTES_COMMAND = 'UpdateChangeRequestAttributesCommand';

  public static ADD_COMMENT_TO_CHANGE_REQUEST_COMMAND = 'AddCommentToChangeRequestCommand';

  public static RESEND_CONTACT_NOTIFICATION_COMMAND = 'ResendContactNotificationCommand';

  public static REVOKE_TLD_COMMAND = 'RevokeTopLevelDomainCommand';

  public static DELEGATE_TLD_COMMAND = 'DelegateTopLevelDomainCommand';

  public static CREATE_USER_COMMAND = 'CreateUserCommand';

  public static UPDATE_USER_COMMAND = 'UpdateUserCommand';

  public static COMPLETE_SIGN_UP_COMMAND = 'CompleteUserSignUpCommand';

  public static INIT_RESET_PASSWORD_COMMAND = 'InitiateResetPasswordCommand';

  public static RESET_PASSWORD_COMMAND = 'ResetPasswordCommand';

  public static CREATE_PASSWORD_COMMAND = 'CreatePasswordCommand';

  public static CHANGE_PASSWORD_COMMAND = 'ChangePasswordCommand';

  public static CREATE_NEW_GTLD_COMMAND = 'CreateNewGtldTokenCommand';

  public static UPDATE_GTLD_TOKEN_COMMAND = 'UpdateGtldTokenCommand';

  public static DELETE_GTLD_TOKEN_COMMAND = 'DeleteGtldTokenCommand';

  public static UPDATE_USER_ACCOUNT_SETTINGS_COMMAND = 'UpdateUserAccountSettingsCommand';

  public static RESEND_USER_INVITATION_COMMAND = 'ResendUserInvitationCommand';

  public static TERMS_AND_PRIVACY_ACKNOWLEDGMENT_COMMAND = 'TermsAndPrivacyAcknowledgmentCommand';
  public static GENERATE_MFA_RECOVERY_CODES_COMMAND = 'GenerateMFARecoveryCodesCommand';


  //Server Field Names
  public static SPONSORING_FIELD_NAME = 'organization';
  public static ADMINISTRATIVE_FIELD_NAME = 'administrative';
  public static TECHNICAL_FIELD_NAME = 'technical';
  public static NAME_SERVERS_FIELD_NAME = 'nameServer';
  public static TRUST_ANCHORS_FIELD_NAME = 'trustAnchor';
  public static WHOIS_FIELD_NAME = 'whois';
  public static REGISTRYURL_FIELD_NAME = 'registryUrl';
  public static RDAP_SERVER_FIELD_NAME = 'rdapServer';
  public static ALL_NAME_SERVERS_FIELD_NAME = 'allNameServers';
  public static ALL_TRUST_ANCHORS_FIELD_NAME = 'allTrustAnchors';
  public static ALL_RDAP_SERVERS_FIELD_NAME = 'allRdapServers';
  public static LOCK_FIELD_NAME = 'locks';
  public static LAST_UPDATE_FIELD_NAME = 'lastUpdated';
  public static AUTH_POLICY_FIELD_NAME = 'authPolicy';
  public static AUTH_POLICY_USERS_FIELD_NAME = 'allPolicyUsers';
  public static META_DATA_FIELD_NAME = 'metadata';
  public static INITIATE_MFA_COMMAND: string = 'InitiateMFACommand';
  public static ACTIVATE_MFA_COMMAND: string = 'ActivateMFACommand';
  public static DISABLE_MFA_COMMAND: string = 'DisableMFACommand';
  public static CREATE_API_TOKENS_COMMAND: string = 'GenerateAPITokenCommand';
  public static RENAME_API_TOKEN_COMMAND: string = 'RenameAPITokenCommand';
  public static REVOKE_API_TOKEN_COMMAND: string = 'RevokeAPITokenCommand';
}
